import axios from "axios";
import { z } from "zod";
import { errorLog } from "../../../logger";
import { FeedId } from "../../Types";
import ValidationError from "../../ZodError";
import { feedsUrl } from "./getFeeds";
const PatchFeedsResponse = z.object({
    feedIds: FeedId.array(),
});
export default async function patchFeed(personId, request, config) {
    const { data } = await axios.patch(feedsUrl(personId), request, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = PatchFeedsResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        errorLog(patchFeed.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(`[${patchFeed.name}] returned unexpected data.`, decoded.error.issues);
    }
}
//# sourceMappingURL=patchFeeds.js.map